module.exports = __webpack_public_path__ + "static/media/files-text.f202e5bd.svg";